<div class="classification-area container">
  <div class="row" [style.minHeight.px]="rowHeight" [appHighlight]="highlightColor" [defaultColor]="defaultColor"
    (color)="handleMouseEvent( $event)">
    <div class="question" [ngClass]="cssClass">
      @if (questionNo) {
        <label class="question-no">{{questionNo}}</label>
      }
      <p class="title-area">{{question}}</p>
    </div>
    <div class="revenue-container" [ngClass]="componentClass">
      <form class="revenueform" action="" [formGroup]="revenueForm">
        <div cbInput [label]="placeHolder" prefix="$" [errorState]="isrevenueValid"
          hideRequiredMarker="true" [class.has-error]="isrevenueValid">
          <input type="text" inputmode="decimal" name="revenue"
            mask="separator.2" thousandSeparator=","
            [formControl]="revenueInputCtrl"
            (keyup)="setEnableFlag($event.target.value)"
            (change)="setEnableFlag($event.target.value)"
            (focusout)="handleFocusOut()" />
          </div>
          @if (isrevenueValid) {
            <p class="validationErrorMsg">
              <span class="bgcircle">i</span>
            {{ errorMessages.revenue.required }}</p>
          }
        </form>
      </div>
    </div>
  </div>